import { render, staticRenderFns } from "./ForgotPasswordForm.vue?vue&type=template&id=21c0cfab&"
import script from "./ForgotPasswordForm.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ForgotPasswordForm.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports